import useProtoMethod from "./useProtoMethod";
import {
  GetSignedUploadsUrlsRequest,
  GetSignedUploadsUrlsResponse,
  GetUrlContentRequest,
  GetUrlContentResponse,
  ConvertAmrAudioRequest,
  ConvertAmrAudioResponse,
} from "protogen/files_service_pb";

const useGetSignedUploadUrls = () => {
  return useProtoMethod<
    GetSignedUploadsUrlsRequest,
    GetSignedUploadsUrlsResponse
  >("GetSignedUploadsUrls", GetSignedUploadsUrlsResponse);
};

const useGetUrlContent = () => {
  return useProtoMethod<GetUrlContentRequest, GetUrlContentResponse>(
    "GetUrlContent",
    GetUrlContentResponse,
  );
};

const useConvertAmrAudio = () => {
  return useProtoMethod<ConvertAmrAudioRequest, ConvertAmrAudioResponse>(
    "ConvertAmrAudio",
    ConvertAmrAudioResponse,
  );
};
export { useGetSignedUploadUrls, useGetUrlContent, useConvertAmrAudio };
